const blogListInit = () => {
  const mainPattern = document.querySelectorAll('.gg-webinars-events-list');
  mainPattern.forEach((module) => {
    const inputAll = module.querySelector('#all');
    const inputs = module.querySelectorAll('input[type="radio"]');
    const articles = module.querySelectorAll('article');
    const pagination = module.querySelectorAll('.gravity-block-dynamic-boxes__pagination-link');
    let anyChecked = false;
      inputs.forEach(input => {
        if (input.checked) {
          anyChecked = true;
          return;
        }
      });
    if (!anyChecked) {
      if(inputAll) {
        inputAll.checked = true;
      }
    }

    articles.forEach((article, index) => {
      article.classList.add('fade-in-up', `delay-${index}`);

      const webinar = article.querySelector('li[data-term="webinars"]');
      const firstGroupWrapper = article.querySelector('.gravity-block-dynamic-boxes__group-wrapper');
      if (webinar) {
        firstGroupWrapper.classList.add('button-play');
      }
    });

    const listPostsResult = module.querySelector('.posts-result__container');
    if (listPostsResult) {
      const observer = new MutationObserver(mutationsList => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(newNode => {
              const webinar = newNode.querySelector('li[data-term="webinars"]');
              const firstGroupWrapper = newNode.querySelector('.gravity-block-dynamic-boxes__group-wrapper');
              if (webinar && firstGroupWrapper) { 
                firstGroupWrapper.classList.add('button-play');
              }
            });
          }
        }
      });
      observer.observe(listPostsResult, {
        childList: true,
        subtree: true
      });
    
      pagination.forEach(paginationLink => {
        paginationLink.addEventListener('click', () => {
          observer.disconnect();
          observer.observe(listPostsResult, {
            childList: true,
            subtree: true
          });
        });
      });
    }
    const inputFilter = module.querySelector('#filter-toggle');
    if (inputFilter) {
      const urlParams = new URLSearchParams(window.location.search);
      const toggleUpcoming = urlParams.get('toggle_upcoming');
      if (toggleUpcoming === null || toggleUpcoming === 'false') {
      inputFilter.checked = false;
      } else {
      inputFilter.checked = true;
      }
    }
  });
}

blogListInit();

